import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortPassengers'
})
export class SortPassengersPipe implements PipeTransform {

  transform(passengers: any[]): any[] {
    if (!passengers || passengers.length === 0) return passengers;

    return passengers.sort((a, b) => {
      const order = { 'Adult': 1, 'Child': 2, 'Infant': 3 };
      return order[a.type] - order[b.type];
    });
  }

}
